import { makeAction } from "async-action-creator";
import * as R from "ramda";

import api from "../../utils/api";
import { createApiThunk } from "../../utils/thunk";

export const FETCH_PROFESSIONS = makeAction("catalogs/FETCH_PROFESSIONS");
export const FETCH_SKILLS = makeAction("catalogs/FETCH_SKILLS");
// export const FETCH_COUNTRIES = makeAction("catalogs/FETCH_COUNTRIES");
export const FETCH_PROVINCES = makeAction("catalogs/FETCH_PROVINCES");
export const FETCH_DISTRICTS = makeAction("catalogs/FETCH_DISTRICTS");
export const FETCH_UNIVERSITIES = makeAction("catalogs/FETCH_UNIVERSITIES");
export const FETCH_UNIVERSITY_COMPANIES = makeAction(
  "catalogs/FETCH_UNIVERSITY_COMPANIES"
);
export const FETCH_TESTS = makeAction("catalogs/FETCH_TESTS");
export const FETCH_STUDIES = makeAction("catalogs/FETCH_STUDIES");

export const fetchProfessions = createApiThunk({
  action: FETCH_PROFESSIONS,
  request: (country, { user }) =>
    country ? api.catalogs.professions.fetch(country, user.locale) : []
});

export const fetchSkills = createApiThunk({
  action: FETCH_SKILLS,
  request: (formData, { user }) =>
    formData && formData.country
      ? api.catalogs.skills.fetch({ ...formData, locale: user.locale })
      : []
});

// export const fetchCountries = createApiThunk({
//   action: FETCH_COUNTRIES,
//   request: (_, { user }) => api.catalogs.countries.fetch(_, user.locale)
// });

export const fetchProvinces = country => async dispatch => {
  dispatch(FETCH_PROVINCES.start());
  let data = [];
  if (country) {
    data = await api.catalogs.provinces.fetch(country);
  }
  dispatch(FETCH_PROVINCES.resolve(data));
};

export const fetchDistricts = provinceId => async dispatch => {
  dispatch(FETCH_DISTRICTS.start());
  let data = [];
  if (provinceId) {
    data = await api.catalogs.districts.fetch(provinceId);
  }
  dispatch(FETCH_DISTRICTS.resolve(data));
};

export const fetchUniversities = createApiThunk({
  action: FETCH_UNIVERSITIES,
  request: country => (country ? api.catalogs.universities.fetch(country) : [])
});

export const fetchUniversityCompanies = createApiThunk({
  action: FETCH_UNIVERSITY_COMPANIES,
  request: api.catalogs.companies.universities
});

export const fetchTests = createApiThunk({
  action: FETCH_TESTS,
  request: async idCompany => {
    if (!idCompany) return [];

    const tests = await api.catalogs.tests.fetch(idCompany);
    // Filter tests
    return R.reject(t => t.disabled, tests);
  }
});

export const fetchStudies = createApiThunk({
  action: FETCH_STUDIES,
  request: (_, { user }) => api.catalogs.fieldsOfStudy.fetch(user.locale)
});
